// extracted by mini-css-extract-plugin
export var centerList = "_k2-6";
export var centerLoc = "_k2-a";
export var centerName = "_k2-9";
export var centerOptionBody = "_k2-8";
export var centerRow = "_k2-7";
export var centerStatus = "_k2-b";
export var empty = "_k2-5";
export var externalIcon = "_k2-c";
export var fieldHeader = "_k2-2";
export var fieldHelp = "_k2-4";
export var fieldLabel = "_k2-3";
export var panel = "_k2-0";
export var removeBtn = "_k2-d";
export var section = "_k2-1";